import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import DocumentRow from "./document-listing/document-row.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationBody",
  components: {
    DocumentRow
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    documents: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    }
  },
  computed: {
    noDocuments() {
      return isEmpty(this.documents.byId);
    }
  },
  methods: {
    getCommentsForDocument(documentId) {
      var _context;
      return _reduceInstanceProperty(_context = this.documents.byId[documentId].comments).call(_context, (acc, commentId) => {
        acc.byId[commentId] = this.comments.byId[commentId];
        return acc;
      }, {
        byId: {}
      });
    }
  }
});